import { ArrowLeft, CreditCard, RefreshCw, XCircle } from "lucide-react";
import React from "react";
import { useNavigate } from "react-router-dom";
import { Button } from "../ui/button";
import {
  Card,
  CardContent,
  CardDescription,
  CardHeader,
  CardTitle,
} from "../ui/card";

const BillingCancelPage: React.FC = () => {
  const navigate = useNavigate();

  const handleGoBack = () => {
    navigate("/billing");
  };

  const handleGoToDashboard = () => {
    navigate("/dashboard");
  };

  return (
    <div className="min-h-screen bg-gradient-to-br from-background to-muted/20 flex items-center justify-center p-6">
      <div className="max-w-2xl w-full">
        <Card className="bg-gradient-to-r from-orange-50 to-red-50 dark:from-orange-950/20 dark:to-red-950/20 border-orange-200 dark:border-orange-800">
          <CardHeader className="text-center">
            <div className="mx-auto mb-4 p-4 rounded-full bg-orange-100 dark:bg-orange-900/30 w-16 h-16 flex items-center justify-center">
              <XCircle className="h-8 w-8 text-orange-600 dark:text-orange-400" />
            </div>
            <CardTitle className="text-3xl font-bold text-orange-900 dark:text-orange-100">
              Payment Cancelled
            </CardTitle>
            <CardDescription className="text-orange-800 dark:text-orange-200 text-lg">
              Your payment process was cancelled
            </CardDescription>
          </CardHeader>

          <CardContent className="space-y-6">
            {/* Cancellation Message */}
            <div className="text-center space-y-4">
              <p className="text-orange-800 dark:text-orange-200">
                No worries! Your payment was cancelled and no charges have been
                made to your account.
              </p>
            </div>

            {/* Information */}
            <div className="bg-white/50 dark:bg-gray-900/50 rounded-lg p-6">
              <h3 className="font-semibold text-orange-900 dark:text-orange-100 mb-4">
                What happened?
              </h3>
              <div className="space-y-3">
                <div className="flex items-center gap-2">
                  <div className="w-2 h-2 bg-orange-600 rounded-full"></div>
                  <span className="text-orange-800 dark:text-orange-200">
                    No charges were made to your account
                  </span>
                </div>
                <div className="flex items-center gap-2">
                  <div className="w-2 h-2 bg-orange-600 rounded-full"></div>
                  <span className="text-orange-800 dark:text-orange-200">
                    You can try again anytime
                  </span>
                </div>
                <div className="flex items-center gap-2">
                  <div className="w-2 h-2 bg-orange-600 rounded-full"></div>
                  <span className="text-orange-800 dark:text-orange-200">
                    Your current plan remains unchanged
                  </span>
                </div>
              </div>
            </div>

            {/* Action Buttons */}
            <div className="space-y-3">
              <Button
                onClick={handleGoBack}
                className="w-full bg-orange-600 hover:bg-orange-700 text-white"
              >
                <RefreshCw className="h-4 w-4 mr-2" />
                Try Payment Again
                <ArrowLeft className="h-4 w-4 ml-2" />
              </Button>

              <Button
                variant="outline"
                onClick={handleGoToDashboard}
                className="w-full"
              >
                <CreditCard className="h-4 w-4 mr-2" />
                Back to Dashboard
              </Button>
            </div>
          </CardContent>
        </Card>
      </div>
    </div>
  );
};

export default BillingCancelPage;
